import { render, staticRenderFns } from "./AgentUplineCarrier.vue?vue&type=template&id=2b531511&"
import script from "./AgentUplineCarrier.vue?vue&type=script&lang=js&"
export * from "./AgentUplineCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports